import { render, staticRenderFns } from "./DadosPix.vue?vue&type=template&id=44110dc0&scoped=true&"
import script from "./DadosPix.vue?vue&type=script&lang=js&"
export * from "./DadosPix.vue?vue&type=script&lang=js&"
import style0 from "./DadosPix.vue?vue&type=style&index=0&id=44110dc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44110dc0",
  null
  
)

export default component.exports